export const getFullStorySessionURL = () => {
  if (!window.FS?.getCurrentSessionURL) return null;
  return window.FS.getCurrentSessionURL();
};
